import { useQuery } from "@tanstack/react-query";

import { getEventsBySport } from "@/services";

import { getEventStatusRefetchInterval } from "../utils/matchOdds";
import { useSportSocketConnected } from "../utils/socketStatus";

/**
 * One sport's events in one status, grouped by league.
 *
 * A sport's live list is filled from the pushed in-play list (useSportSocket),
 * so its poll pauses while the socket is up. `fetch: false` only reads what
 * the sport page has loaded, so the sidebar can count from the same list
 * without a request of its own.
 */
export const useSportEvents = (sportSlug: string, eventStatus: string, { fetch = true } = {}) => {
  const pushed = useSportSocketConnected() && eventStatus === "live";
  return useQuery({
    queryKey: ["sport-events", sportSlug, eventStatus],
    queryFn: () => getEventsBySport(sportSlug, eventStatus),
    enabled: fetch && Boolean(sportSlug),
    refetchInterval: pushed ? false : getEventStatusRefetchInterval(eventStatus),
  });
};
